module.exports = __webpack_public_path__ + "static/invoice-mobile-d8828184680f904abc22c6ce4ac36447.png";